import { merchantReportHref } from './merchant-search.ts'
import { merchantLabel, type Merchant } from './merchants.ts'
import type { InternalPage } from './pages.ts'
import type { SearchDateRange } from './search-date-range.ts'

/** Build a report link with only the scope parameters its filters read. */
export function scopedSearchResult(
  page: Pick<InternalPage, 'path' | 'takesMerchants' | 'takesDateRange'>,
  date: Pick<SearchDateRange, 'label' | 'range'>,
  merchant?: Merchant | null
): { href: string; label: string } {
  const params = new URLSearchParams()
  const labels: string[] = []
  if (page.takesDateRange && date.range) {
    params.set('period', 'custom')
    params.set('from', date.range.startDate)
    params.set('to', date.range.endDate)
    if (date.label) labels.push(date.label)
  }
  if (page.takesMerchants && merchant) {
    labels.push(merchantLabel(merchant))
    return {
      href: merchantReportHref(page.path, params.toString(), merchant.orgId),
      label: ` · ${labels.join(' · ')}`
    }
  }
  return {
    href: params.size ? `${page.path}?${params}` : page.path,
    label: labels.length ? ` · ${labels.join(' · ')}` : ''
  }
}
